export const formatDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("pt-BR");
};

export const timeAgo = (value) => {
  if (!value) return "";
  const diff = Date.now() - new Date(value).getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return "agora mesmo";
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `há ${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `há ${days} dia${days > 1 ? "s" : ""}`;
  const months = Math.floor(days / 30);
  if (months < 12) return `há ${months} ${months > 1 ? "meses" : "mês"}`;
  const years = Math.floor(months / 12);
  return `há ${years} ano${years > 1 ? "s" : ""}`;
};

export const audienceLabel = (value) => {
  const map = {
    ATACADO: "Atacado",
    VAREJO: "Varejo",
    FOOD_SERVICE: "Food Service",
  };
  return map[value] || value || "-";
};

export const statusLabel = (value) => {
  const map = {
    PENDENTE: "Pendente",
    APROVADO: "Aprovado",
    REJEITADO: "Rejeitado",
    PAUSADO: "Pausado",
    EXPIRADO: "Expirado",
  };
  return map[value] || value || "-";
};

export const statusTone = (value) => {
  if (!value) return "info";
  if (value === "APROVADO") return "success";
  if (value === "PENDENTE") return "warning";
  if (value === "REJEITADO") return "danger";
  if (value === "PAUSADO" || value === "EXPIRADO") return "info";
  return "info";
};
